import React, { useContext, useMemo, type PropsWithChildren } from 'react';

type Value = {
  onClose: () => void;
};
const MenuContext = React.createContext<Value | undefined>(undefined);

interface Props {
  onClose: () => void;
}
export const MenuProvider: React.FC<PropsWithChildren<Props>> = ({ children, onClose }) => {
  const value = useMemo(
    () => ({
      onClose,
    }),
    [onClose],
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenu = () => {
  const value = useContext(MenuContext);
  if (!value) throw new Error('Missing MenuContext Provider');
  return value;
};
